import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  ChartData,
  ChartOptions,
  Tooltip as ChartTooltip,
} from 'chart.js';
import { LEGACY_COLORS } from '../../../constants/graphColors';
import analyseTranslation from '../../../constants/AnalyseTranslation.json';

ChartJS.register(BarElement, CategoryScale, ChartTooltip);

type AnalyseAverageProps = {
  progress: number;
};

const generateDataSet = (progress: number) => ({
  labels: ['Today'],
  datasets: [
    {
      label: 'Average Progress',
      backgroundColor: LEGACY_COLORS.lightGreenOpacity,
      hoverBackgroundColor: LEGACY_COLORS.lightGreenOpacity,
      borderColor: LEGACY_COLORS.lightGreenOpacity,
      borderWidth: 1,
      data: [progress],
    },
  ],
});

const options: ChartOptions<'bar'> = {
  scales: {
    y: {
      offset: true,
      stacked: true,
      max: 100,
      ticks: {
        stepSize: 20,
      },
    },
    x: {
      offset: true,
      ticks: {
        color: LEGACY_COLORS.blackOpacity,
      },
      border: {
        display: false,
      },
    },
  },
  layout: {
    padding: {
      top: 20,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      usePointStyle: true,
      xAlign: 'center',
      yAlign: 'bottom',
      position: 'nearest',
      enabled: true,
      displayColors: false,
      titleMarginBottom: 8,
      padding: 12,
      cornerRadius: 6,
      caretSize: 8,
      callbacks: {
        title: () => ['Today'],
        label: tooltipItems => {
          return ['Average', `Progress: ${tooltipItems.parsed.y}%`];
        },
      },
    },
  },
  responsive: false,
  maintainAspectRatio: false,
};

const AnalyseAverage: React.FC<AnalyseAverageProps> = ({ progress }) => {
  const data: ChartData<'bar'> = generateDataSet(progress);

  return (
    <div className="analyse-average analyse__border">
      <p className="title home-container__analyse-title">
        {analyseTranslation.progress}
        <Tooltip title={analyseTranslation.tooltip.progress}>
          <InfoCircleOutlined className="ml-1" />
        </Tooltip>
      </p>
      <Bar data={data} options={options} width={155} height={240} />
    </div>
  );
};

export default AnalyseAverage;
